<script setup lang="ts">
import Accordeon, { type AccordeonEmits } from '@/components/Accordion/index.vue'
import TableRowElementalItem from '@/components/Library/TableLibrary/TableRowElementalItem/index.vue'
import TableAccordeonTrigger from '@/components/Library/TableLibrary/TableAccordeonTrigger/index.vue'
import TableRowSkeleton from '@/components/Library/TableLibrary/TableRowSkeleton/index.vue'
import IconBox from '@/components/DrawerSidebarRight/components/shared/IconBox.vue'

const props = defineProps<{
  title: string
  iconClass: string
  iconName: string
  elementals: any[]
  isOpen: boolean
  isLoading: boolean
  showEmptyState?: boolean
  columns: string[]
  folderLevel: number
  rowClass?: string
  elementalLabel?: string
}>()

const emits = defineEmits<AccordeonEmits>()
const accordionRef = ref()

const handleToggle = (isOpen?: boolean) => {
  emits('onToggle', isOpen)
}
</script>

<template>
  <Accordeon
    ref="accordionRef"
    :is-open="isOpen"
    @on-toggle="handleToggle"
  >
    <template #header>
      <button class="w-full" @click="() => accordionRef?.toggle()">
        <TableAccordeonTrigger :title="title" class="border-grayLighter border-b">
          <template #icon>
            <IconBox :class="iconClass">
              <span class="flex-shrink-0 h-6" :class="iconName" />
            </IconBox>
          </template>
        </TableAccordeonTrigger>
      </button>
    </template>

    <template #content>
      <div v-if="isLoading">
        <TableRowSkeleton :columns="columns" :folder-level="folderLevel" />
      </div>
      <div v-else-if="elementals.length > 0">
        <TableRowElementalItem
          v-for="list in elementals"
          :key="list.id"
          :elemental="list"
          :elementals-type="list.elementalTypeId"
          :is-list-element="true"
          :parent-list-id="list.id"
          :columns="columns"
          :folder-level="folderLevel"
          :row-class="rowClass"
          :elemental-label="elementalLabel"
        />
      </div>
      <div v-else-if="showEmptyState" class="text-center space-y-4 p-4 bg-[#F6F6FF]">
        <p class="text-gray-500 text-sm">
          No items
        </p>
      </div>
    </template>
  </Accordeon>
</template>
